import { render } from "./menu_master.vue?vue&type=template&id=5c7dd42b&scoped=true"
import script from "./menu_master.vue?vue&type=script&lang=js"
export * from "./menu_master.vue?vue&type=script&lang=js"

import "./menu_master.vue?vue&type=style&index=0&id=5c7dd42b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7dd42b"]])

export default __exports__